import * as React from 'react';
import type { SVGProps } from 'react';
interface SVGRProps {
  title?: string;
  titleId?: string;
}
const SvgExternalLink = ({ title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps) => (
  <svg
    width={24}
    height={24}
    viewBox='0 0 24 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      d='M10.0002 12.5852C9.60967 12.9757 9.60933 13.6085 10.0002 13.9994C10.2232 14.2224 10.5241 14.3179 10.814 14.2863C11.0334 14.263 11.2464 14.1673 11.4144 13.9994L18.0003 7.41417V9.2358C18.0001 9.58538 18.1798 9.89319 18.4515 10.0717C18.6092 10.1751 18.7975 10.2353 19.0002 10.2357C19.5526 10.2357 20.0002 9.78806 20.0002 9.23563L19.9973 4.00017L14.7591 4C14.2067 4 13.759 4.44764 13.759 5.00007C13.7592 5.55232 14.2067 5.99979 14.7589 5.99996H16.5861L10.0002 12.5852Z'
      fill='#0062D1'
    />
    <path
      d='M4 7.50005C4 6.67162 4.67157 6.00005 5.5 6.00005H11.6362L9.63623 8.00005H6V18H16V14.3642L18 12.3642V18.5C18 19.3285 17.3284 20 16.5 20H5.5C4.67157 20 4 19.3285 4 18.5V7.50005Z'
      fill='#0062D1'
    />
  </svg>
);
export default SvgExternalLink;
